import { render } from "./DettaglioRapportino.vue?vue&type=template&id=18cd434c&scoped=true"
import script from "./DettaglioRapportino.vue?vue&type=script&lang=js"
export * from "./DettaglioRapportino.vue?vue&type=script&lang=js"

import "./DettaglioRapportino.vue?vue&type=style&index=0&id=18cd434c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cd434c"]])

export default __exports__